var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"mr-auto"},[_c('a',{attrs:{"href":_vm.url}},[_vm._v("FASA")]),_vm._v(" © 2019")]),_vm._v(" "),_c('span',{staticClass:"mx-auto"},[_c('strong',[_vm._v("v"+_vm._s(_vm.versao))])]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by PazNet")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21abe825","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/Footer.vue
// module id = 540
// module chunks = 30